import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { ArrowRightCircle } from 'lucide-react';

export default function ProfessionalServices() {
  return (
    <div>
      <div className="relative w-full min-h-[700px] lg:min-h-[600px] bg-[#373737] text-white">
        {/* Background image (lower 4/5) */}
        <div className="absolute bottom-0 left-0 w-full h-[500px] z-0">
          <Image
            src="/background-professionalService.svg"
            alt="Background building"
            layout="fill"
            objectFit="cover"
            className="pointer-events-none"
          />
        </div>

        {/* Content */}
        <div className="relative z-10 grid grid-cols-1 md:grid-cols-5 h-full px-6 py-10 md:px-0 md:py-0">
          <div className="hidden md:block"></div>
          <div className="col-span-2 flex flex-col justify-start space-y-8 mt-10 md:mt-20 md:pl-4">
            <h2 className="text-[#BF984D] text-3xl md:text-5xl leading-snug">
              Professional Services
            </h2>

            <div className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <Image
                src="/background-professionalService logo.svg"
                alt="Simplicity Certified"
                width={60}
                height={60}
              />
              <div className="leading-tight">
                <span className="text-2xl font-bold">SIMPLICITY</span>
                <sup className="text-lg font-bold">®</sup>{' '}
                <span className="text-xl">Certified</span>
                <br />
                <span className="text-sm font-light text-[#A09D9D] tracking-wide">
                  Built with Simplicity Business Software
                </span>
              </div>
            </div>

            <p className="text-sm md:text-base font-light text-[#A09D9D] tracking-wide max-w-md">
              Professional Services Providers are classified into 3 tiers
              depending on their pool and depth of technical and functional
              expertise.
            </p>

            <Link href="https://anacle.com/contact-us/">
              <button className="mt-4 md:mt-10 text-base md:text-xl font-semibold w-full sm:w-8/12 md:w-6/12 h-[50px] flex justify-between items-center px-4 border border-[#BF984D] text-[#BF984D]">
                <span>Find Out More</span>
                <ArrowRightCircle size="28" />
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="w-full h-[35px] bg-[#2c2c2c] border-t border-gray-400" />
    </div>
  );
}
